import { render } from "./resultInfo.vue?vue&type=template&id=006a58aa&scoped=true"
import script from "./resultInfo.vue?vue&type=script&lang=js"
export * from "./resultInfo.vue?vue&type=script&lang=js"

import "./resultInfo.vue?vue&type=style&index=0&id=006a58aa&lang=scss&scoped=true"

import exportComponent from "D:\\XGprogect\\海尔会员\\haierhuiyuan-phone\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006a58aa"]])

export default __exports__